import { connect } from 'react-redux';
import InvoiceSalesAudit from './InvoiceSalesAudit';

import { selectors as uiSelectors } from 'ducks/ui';
import { selectors as operationSelectors } from 'ducks/uiOperations';
import { selectors as formSelectors } from 'ducks/form';
import { selectors as auditDetailsSelectors } from 'ducks/salesInvoiceEnquiry/SalesAuditDetails';

const mapStateToProps = (state) => ({
  operationMode: operationSelectors.operationMode(state),
  selectedTab: uiSelectors.selectedTab(state),
  selectedForm: formSelectors.selected(state),
  auditDetailsSummary: auditDetailsSelectors.summary(state),
});

export default connect(mapStateToProps, {})(InvoiceSalesAudit);
